export default __webpack_public_path__ + "static/media/get_support.a317f96c.svg";